import React, { FC } from 'react';
import { IconCloseFill } from '@saucelabs/ds-icons';
import { IconButton } from '@saucelabs/ds-button';

import KeyBind from '../../common/KeyBind';

interface OverlayCloseButtonProps {
  onPress: () => void
}

export const OverlayCloseButton: FC<OverlayCloseButtonProps> = ({ onPress }) => (
  <KeyBind
    char="esc"
    func={onPress}
    label="Close diff overlay"
  >
    <IconButton
      className="text-gray-600 p-1.5"
      icon={<IconCloseFill />}
      onPress={onPress}
      size="sm"
      variant="text"
    />
  </KeyBind>
);

export default OverlayCloseButton;
